// src/components/PrivacyPolicy.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

const Section = ({ title, children }) => (
  <div style={{ marginBottom: "32px" }}>
    <h2
      style={{
        fontSize: "16px",
        fontWeight: 700,
        color: "#40BEB4",
        letterSpacing: "0.5px",
        marginBottom: "12px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <span
        style={{
          display: "inline-block",
          width: "3px",
          height: "16px",
          background: "#40BEB4",
          borderRadius: "2px",
          flexShrink: 0,
        }}
      />
      {title}
    </h2>
    <div style={{ color: "rgba(255,255,255,0.65)", fontSize: "14px", lineHeight: "1.8", paddingLeft: "13px" }}>
      {children}
    </div>
  </div>
);

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        background: "linear-gradient(160deg, #071520 0%, #0a1e2e 35%, #071018 100%)",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "48px 24px 72px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Grid background */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `
            linear-gradient(rgba(64,190,180,0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(64,190,180,0.03) 1px, transparent 1px)
          `,
          backgroundSize: "48px 48px",
          pointerEvents: "none",
        }}
      />

      {/* Back button */}
      <div style={{ width: "100%", maxWidth: "720px", marginBottom: "32px", position: "relative", zIndex: 1 }}>
        <button
          onClick={() => navigate(-1)}
          style={{
            background: "rgba(64,190,180,0.08)",
            border: "1px solid rgba(64,190,180,0.2)",
            color: "#40BEB4",
            padding: "8px 20px",
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "13px",
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
            gap: "6px",
          }}
        >
          ← Back
        </button>
      </div>

      {/* Card */}
      <div
        style={{
          maxWidth: "720px",
          width: "100%",
          background: "rgba(10, 25, 40, 0.92)",
          backdropFilter: "blur(12px)",
          border: "1px solid rgba(64,190,180,0.2)",
          borderRadius: "24px",
          padding: "48px",
          position: "relative",
          zIndex: 1,
          boxShadow: `
            0 0 0 1px rgba(255,255,255,0.03) inset,
            0 24px 64px rgba(0,0,0,0.6),
            0 0 48px rgba(64,190,180,0.07)
          `,
        }}
      >
        {/* Header */}
        <div style={{ marginBottom: "40px", textAlign: "center" }}>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "48px",
              height: "48px",
              borderRadius: "12px",
              background: "rgba(64,190,180,0.1)",
              border: "1px solid rgba(64,190,180,0.25)",
              marginBottom: "16px",
              fontSize: "22px",
            }}
          >
            🔒
          </div>
          <h1
            style={{
              fontSize: "28px",
              fontWeight: 700,
              color: "#40BEB4",
              marginBottom: "8px",
              letterSpacing: "-0.3px",
            }}
          >
            Privacy Policy
          </h1>
          <p style={{ color: "rgba(255,255,255,0.35)", fontSize: "13px" }}>
            Last updated: {new Date().toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}
          </p>
        </div>

        {/* Divider */}
        <div
          style={{
            height: "1px",
            background: "linear-gradient(90deg, transparent, rgba(64,190,180,0.25), transparent)",
            marginBottom: "36px",
          }}
        />

        <Section title="Data Collection">
          We collect Aadhaar details through DigiLocker for identity verification (KYC) purposes.
          User consent is obtained before accessing any personal data.
        </Section>

        <Section title="Data Usage & Retention">
          We do not store Aadhaar data permanently. All data is securely processed and used only
          for verification. Once verification is complete, sensitive data is not retained on our
          servers beyond what is legally required.
        </Section>

        <Section title="Security Practices">
          We follow industry-standard security practices to protect user data. All communications
          are encrypted in transit, and access to personal data is strictly limited to authorized
          personnel involved in the verification process.
        </Section>

        <Section title="User Rights">
          You have the right to know what data is collected, how it is used, and to withdraw
          consent at any time. Withdrawing consent may prevent completion of the KYC process.
        </Section>

        <Section title="Contact for Privacy Concerns">
          For any privacy-related concerns or data requests, please contact us at{" "}
          <a
            href="mailto:advitiyaoffice@gmail.com"
            style={{ color: "#40BEB4", textDecoration: "none", borderBottom: "1px solid rgba(64,190,180,0.4)" }}
          >
            advitiyaoffice@gmail.com
          </a>
          .
        </Section>

        {/* Bottom divider */}
        <div
          style={{
            height: "1px",
            background: "linear-gradient(90deg, transparent, rgba(64,190,180,0.15), transparent)",
            marginTop: "8px",
          }}
        />
      </div>
    </div>
  );
};

export default PrivacyPolicy;
